<script lang="ts">
  import { onMount } from 'svelte'
  import Chart from 'chart.js/auto'

  export let data: any
  export let options: any

  let chartDom: HTMLCanvasElement | undefined
  let chartRef: Chart | null = null

  // Create a deep clone of the data to avoid Svelte reactivity conflicts
  const cloneData = (data: any) => {
    return JSON.parse(JSON.stringify(data))
  }

  $: config = {
    type: 'line',
    data: cloneData(data), // Use cloned data
    options: {
      interaction: {
        mode: 'index',
        intersect: false,
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        uciconplugin:{
          enabled: true,
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        title: {
          display: true,
          text: 'Accessibility Score over time'
        }
      },
      scales: {
        x: {
          type: 'category',
          display: true,
        },
        y: {
          type: 'linear',
          display: true,
          beginAtZero: true,
          min: 0,
          max: 100,
        }
      },
      ...(options ?? {})
    },
  }

  $: if (chartRef && data) {
    chartRef.data = cloneData(data) // Use cloned data
    chartRef.update('none') // Use 'none' for faster updates
  }

  onMount(()=> {
    if(chartDom) {
      chartRef = new Chart(chartDom, config as any)
    }
    
    return () => {
      if(chartRef) {
        chartRef.destroy()
      }
    }
  })
</script>

<canvas
  class="relative" 
  width="500" height="300"
  aria-label="15-week Web Accessibility Score performance comparison chart showing weekly trend data"
  bind:this={chartDom}
  >
  Line chart showing 15-week web accessibility performance trends with weekly data points
</canvas>